export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99992 9.99999C11.8416 9.99999 13.3333 8.50833 13.3333 6.66666C13.3333 4.82499 11.8416 3.33333 9.99992 3.33333C8.15825 3.33333 6.66658 4.82499 6.66658 6.66666C6.66658 8.50833 8.15825 9.99999 9.99992 9.99999ZM9.99992 11.6667C7.77492 11.6667 3.33325 12.7833 3.33325 15V16.6667H16.6666V15C16.6666 12.7833 12.2249 11.6667 9.99992 11.6667Z"
      fill="var(--color-neutral-200)"
    />
  </svg>
)

export const PasswordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.9999 6.66667H14.1666V5C14.1666 2.7 12.2999 0.833332 9.99992 0.833332C7.69992 0.833332 5.83325 2.7 5.83325 5V6.66667H4.99992C4.08325 6.66667 3.33325 7.41667 3.33325 8.33333V16.6667C3.33325 17.5833 4.08325 18.3333 4.99992 18.3333H14.9999C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V8.33333C16.6666 7.41667 15.9166 6.66667 14.9999 6.66667ZM9.99992 14.1667C9.08325 14.1667 8.33325 13.4167 8.33325 12.5C8.33325 11.5833 9.08325 10.8333 9.99992 10.8333C10.9166 10.8333 11.6666 11.5833 11.6666 12.5C11.6666 13.4167 10.9166 14.1667 9.99992 14.1667ZM12.5833 6.66667H7.41658V5C7.41658 3.575 8.57492 2.41667 9.99992 2.41667C11.4249 2.41667 12.5833 3.575 12.5833 5V6.66667Z"
      fill="var(--color-neutral-200)"
    />
  </svg>
)

export const ErrorIcon = () => (
  <svg width="50" height="50" viewBox="0 0 14 14">
    <path
      d="M7.00004 0.333313C3.32004 0.333313 0.333374 3.31998 0.333374 6.99998C0.333374 10.68 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.68 13.6667 6.99998C13.6667 3.31998 10.68 0.333313 7.00004 0.333313ZM7.66671 10.3333H6.33338V8.99998H7.66671V10.3333ZM7.66671 7.66665H6.33338V3.66665H7.66671V7.66665Z"
      fill="var(--color-error)"
    />
  </svg>
)
